"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
var refund_request_1 = require("./refund_request");
var RefundTypeSelector = function (props) {
    if (props.userType === refund_request_1.IUserType.SELLER && props.refundRequest.isPersisted) {
        return null;
    }
    function renderFullRefundTypeText() {
        if (!props.order.hasPreviousRefund) {
            return I18n.t("discovery.dashboard.refundRequests." + props.userType + ".refundType.full");
        }
        var hasTaxRemittedByReverb = props.order.reverbRemittedTaxAmountAvailableToRefund.amountCents !== 0;
        var viewingAsSeller = props.userType === refund_request_1.IUserType.SELLER;
        if (hasTaxRemittedByReverb && !viewingAsSeller) {
            return I18n.t("discovery.dashboard.refundRequests." + props.userType + ".refundType.remainingPlusTax", {
                amount: props.order.amountAvailableToRefund.display,
                amountTax: props.order.reverbRemittedTaxAmountAvailableToRefund.display,
            });
        }
        return I18n.t("discovery.dashboard.refundRequests." + props.userType + ".refundType.remaining", {
            amount: props.order.amountAvailableToRefund.display,
        });
    }
    return (React.createElement("div", { className: "scaling-mb-2" },
        React.createElement("div", { className: "form-group" },
            React.createElement("div", { className: "form-group__header" }, I18n.t("discovery.dashboard.refundRequests." + props.userType + ".refundType.title")),
            React.createElement("div", { className: "form-group__fields" },
                React.createElement("div", { className: "label-with-radio" },
                    React.createElement("input", { type: "radio", name: "order_refund_request[refund_type]", id: "order_refund_request_refund_type_" + refund_request_1.IRefundType.FULL, value: refund_request_1.IRefundType.FULL, checked: props.refundType === refund_request_1.IRefundType.FULL, onChange: props.onRefundTypeChange }),
                    React.createElement("label", { htmlFor: "order_refund_request_refund_type_" + refund_request_1.IRefundType.FULL }, renderFullRefundTypeText())),
                React.createElement("div", { className: "label-with-radio" },
                    React.createElement("input", { type: "radio", name: "order_refund_request[refund_type]", id: "order_refund_request_refund_type_" + refund_request_1.IRefundType.PARTIAL, value: refund_request_1.IRefundType.PARTIAL, checked: props.refundType === refund_request_1.IRefundType.PARTIAL, onChange: props.onRefundTypeChange }),
                    React.createElement("label", { htmlFor: "order_refund_request_refund_type_" + refund_request_1.IRefundType.PARTIAL }, I18n.t("discovery.dashboard.refundRequests." + props.userType + ".refundType.partial")))))));
};
exports.default = RefundTypeSelector;
//# sourceMappingURL=refund_type_selector.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/refund_requests/refund_type_selector.js
// module id = 3bTq
// module chunks = 20 21